import { TITLE_GENERATOR_CATEGORY } from '../../constants';
import { chipValues } from '../../data/title-generator-fields/shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'titleGeneratorType',
      analyticsName: 'title_generator_type',
      textLabel: 'Generate title for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: chipValues[0],
    },
  },
  {
    type: 'input',
    properties: {
      name: 'titleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'title_generator_topic',
      placeholder: 'Try "Essay title about the impact of sports on career development"',
      textLabel: 'Describe the placement + topic of your title',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
